import styled from 'styled-components'

export const MaintainWrapper = styled.div`
    padding: 16px;
    text-align: center;
    .maintain {
        max-width: 37%;
        @media only screen and (max-width: 1024px) {
            max-width: 50%;
        }
        @media only screen and (max-width: 767px) {
            max-width: 60%;
        }
    }
`
export const MaintainText = styled.div`
    font-weight: 500;
    padding-bottom: 4px;
    font-size: 24px;
    @media only screen and (max-width: 767px) {
        font-size: 18px;
    }
`